import mixpanel from 'mixpanel-browser';
import { MIXPANEL_TOKEN } from "../constants/appConstants";

const mixpanelFeatureOn = false

if (mixpanelFeatureOn) {
    mixpanel.init(MIXPANEL_TOKEN, { debug: false, track_pageview: false, persistence: 'localStorage' });
}

export const trackEvent = (eventName, properties) => {
    if (mixpanelFeatureOn) {
        mixpanel.track(eventName, properties);
    }
};

export const identifyUser = (userId, userProperties) => {
    mixpanel.identify(userId);
    mixpanel.people.set(userProperties);
};

export const resetUser = () => {
    mixpanel.reset();
};

// can be tested and used if it is requred to remove the 'mixpanel-browser' import from the app bundle
// // lazyMixpanel.js
// import { MIXPANEL_TOKEN } from "../constants/appConstants";

// // Feature toggle: only initialize Mixpanel if true
// const mixpanelFeatureOn = true;

// let mixpanelInstance = null;
// let mixpanelPromise = null;
// const pendingQueue = [];

// // Flush queued calls once Mixpanel is loaded
// function flushQueue(mp) {
//   while (pendingQueue.length) {
//     const fn = pendingQueue.shift();
//     try {
//       fn(mp);
//     } catch (e) {
//       console.warn("Mixpanel queued call failed:", e);
//     }
//   }
// }

// // Call immediately if loaded, else enqueue
// function callOrQueue(fn) {
//   if (!mixpanelFeatureOn) return; // skip if feature off
//   if (mixpanelInstance) {
//     fn(mixpanelInstance);
//   } else {
//     pendingQueue.push(fn);
//   }
// }

// /**
//  * Initialize Mixpanel
//  * Only runs if feature flag is on
//  * @param  {...any} args - optional custom init args
//  * @returns {Promise<any>|undefined}
//  */
// export function init(...args) {
//   if (!mixpanelFeatureOn) return;

//   if (!mixpanelPromise) {
//     mixpanelPromise = import("mixpanel-browser")
//       .then(({ default: mp }) => {
//         // Use MIXPANEL_TOKEN if no custom args passed
//         if (args.length === 0) {
//           mp.init(MIXPANEL_TOKEN, {
//             debug: false,
//             track_pageview: false,
//             persistence: "localStorage",
//           });
//         } else {
//           mp.init(...args);
//         }

//         mixpanelInstance = mp;
//         flushQueue(mp);
//         return mp;
//       })
//       .catch((err) => {
//         console.error("Failed to load Mixpanel:", err);
//         mixpanelPromise = null; // reset so we can retry
//       });
//   }
//   return mixpanelPromise;
// }

// /** Track an event */
// export function track(...args) {
//   callOrQueue((mp) => mp.track(...args));
// }

// /** Identify a user */
// export function identifyUser(...args) {
//   callOrQueue((mp) => mp.identify(...args));
// }

// /** Reset current user */
// export function resetUser() {
//   callOrQueue((mp) => mp.reset());
// }